export function MotdViewModel(data) {
  this.Title = data.Title;
  this.Message = data.Message;
  this.Hash = data.Hash;
  this.Style = data.Style;
  this.ContentLayout = data.ContentLayout;
}
